import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import MDTAnchor from '../../../../atoms/mdt-anchor/index.js'
import { MDTApp } from '../../../../../actions/bootAction.js';
import {
  initNotification,
  showHideWsNotification,
} from '../../../../../actions/NotificationRealtimeStore.js';
import ShowToastify from './showToastify.js';
import { IconSet } from '../../../../atoms/mdt-iconset/index.js';
import { sendEventTrackingData } from '../../../../../helpers/commonUtils.js';

import './serverNotification.css';

const ServerNotification = (props) => {
  const [notificationListUrl] = useState(
    MDTApp.getSetting('links.notifications')
  );
  const [autoClose] = useState(
    window.MDTSetting.webSocketNotificationAutoClose || 5000
  );
  const { notificationCount, latestNotification, showNotification } = props;

  useEffect(() => {
    if (props.customer) {
      props.notificationInvoke();
    }
  }, [props]);

  const trackNotificationClick = () => {
    const eventParamObj = {
      eventCategory: 'globalHeader',
      eventAction: 'notification',
      eventLabel: props.pageName,
      processLabels: false,
    };
    sendEventTrackingData(eventParamObj);
  };
  const redirectToNotifications = () => {
    trackNotificationClick();
    MDTApp.goto(MDTApp.getSetting('links.notifications'));
  };

  const autoHideNotification = () => {
    setTimeout(() => {
      props.hideNotificationInvoke(false);
    }, autoClose);
    return true;
  };

  const prop = {
    notificationMsg:
      latestNotification &&
      latestNotification.RenderedOutput &&
      latestNotification.RenderedOutput.Subject
        ? latestNotification.RenderedOutput.Subject
        : '',
  };

  const budgeClass =
    'badge' +
    (notificationCount && notificationCount.unreadCount > 99 ? ' large' : '');

  return (
    <div className="server-notification-count">
      <MDTAnchor onClick={redirectToNotifications} href="javascript:void(0)">
        <IconSet
          name={
            !!(notificationCount && notificationCount.unreadCount > 0)
              ? 'filledBell'
              : 'unfilledBell'
          }
        />
        {!!(notificationCount && notificationCount.unreadCount > 0) ? (
          <span name="badge" className={budgeClass}>
            {notificationCount.unreadCount}
          </span>
        ) : (
          ''
        )}
      </MDTAnchor>
      {!_.isEmpty(latestNotification) &&
        showNotification &&
        autoHideNotification() && <ShowToastify {...prop} />}
    </div>
  );
};

const mapStateToProps = (state, ownProps) => {
  return {
    notificationCount: state.notification.count,
    latestNotification: state.notification.latestNotification,
    showNotification: state.notification.latestNotificationShow,
    customer: state.meDetails.customerId,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    notificationInvoke: () => dispatch(initNotification()),
    hideNotificationInvoke: (data) => dispatch(showHideWsNotification(data)),
    redirectTo: (pagename, data, queryObj) => dispatch({ type: pagename, payload: data, query: queryObj }),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ServerNotification);
